var DatasetService = /** @class */ (function () {
    function DatasetService(api) {
        this.API = api;
    }
    DatasetService.prototype.addDataset = function (dataset) {
        var url = '/datasets';
        return this.API.post(url, dataset);
    };
    DatasetService.prototype.addColumn = function (datasetId, column) {
        var url = "/datasets/".concat(datasetId, "/fields");
        return this.API.post(url, column);
    };
    DatasetService.prototype.updateColumn = function (datasetId, column) {
        var url = "/datasets/".concat(datasetId, "/fields/").concat(column.id);
        return this.API.patch(url, column);
    };
    DatasetService.prototype.deleteColumn = function (datasetId, columnId) {
        var url = "/datasets/".concat(datasetId, "/fields/").concat(columnId);
        return this.API.delete(url, columnId);
    };
    DatasetService.prototype.addRow = function (datasetId, row, appId) {
        var url = "/datasets/".concat(datasetId, "?app=").concat(appId);
        return this.API.post(url, row);
    };
    DatasetService.prototype.updateRow = function (datasetId, row, appId) {
        var url = "/datasets/".concat(datasetId, "/").concat(row.id, "?app=").concat(appId);
        return this.API.put(url, row);
    };
    DatasetService.prototype.updateRowDraft = function (datasetId, row) {
        var url = "/datasets/".concat(datasetId, "/").concat(row.id);
        return this.API.patch(url, row, this.API.IS_DRAFTABLE);
    };
    DatasetService.prototype.deleteRow = function (datasetId, row) {
        var url = "/datasets/".concat(datasetId, "/").concat(row);
        return this.API.delete(url);
    };
    DatasetService.prototype.getColumns = function (datasetId, noDraft) {
        var url = "/datasets/".concat(datasetId, "/meta");
        return this.API.get(url, { noDraft: noDraft });
    };
    DatasetService.prototype.getRows = function (datasetId, query) {
        var url = query
            ? "/datasets/".concat(datasetId).concat(query)
            : "/datasets/".concat(datasetId);
        return this.API.get(url);
    };
    DatasetService.prototype.getRow = function (datasetId, rowId) {
        var url = "/datasets/".concat(datasetId, "/").concat(rowId);
        return this.API.get(url);
    };
    DatasetService.prototype.getUsage = function (datasetId, appId) {
        var url = "/datasets/".concat(datasetId, "/usage?app_id=").concat(appId);
        return this.API.get(url);
    };
    DatasetService.prototype.listDatasets = function (appId, query) {
        var url = '/datasets?';
        if (appId) {
            url += "app=".concat(appId, "&");
        }
        if (query) {
            url += query;
        }
        return this.API.get(url);
    };
    DatasetService.prototype.deleteDataset = function (datasetId) {
        var url = "/datasets/".concat(datasetId);
        return this.API.delete(url);
    };
    DatasetService.prototype.disConnectDataset = function (datasetId, sharedApp) {
        var url = "/datasets/".concat(datasetId, "/disconnect?sharedApp=").concat(sharedApp);
        return this.API.patch(url);
    };
    DatasetService.prototype.shareDataset = function (sharedApp, datasetData) {
        var url = "/datasets/share?sharedApp=".concat(sharedApp);
        return this.API.patch(url, datasetData);
    };
    DatasetService.prototype.updateDataset = function (datasetId, datasetData) {
        var url = "/datasets/".concat(datasetId);
        return this.API.put(url, datasetData);
    };
    DatasetService.prototype.cloneDataset = function (appId, name, datasetId, template_with_data, currentApp) {
        var url = "/datasets/".concat(datasetId, "/clone?app=").concat(currentApp);
        return this.API.post(url, {
            dataset: {
                app: appId,
                name: name,
            },
            template_with_data: template_with_data,
        });
    };
    DatasetService.prototype.exportToExcel = function (datasetId) {
        var url = "/datasets/".concat(datasetId, "/export");
        return this.API.getFile(url);
    };
    DatasetService.prototype.importItemsExcel = function (datasetId, formData) {
        var url = "/datasets/".concat(datasetId, "/import");
        return this.API.postFormData(url, formData);
    };
    DatasetService.prototype.importExcel = function (formData, appId) {
        var url = '/datasets/import';
        return this.API.postFormData(url, formData, { appId: appId });
    };
    DatasetService.prototype.updateDatasetColumnOrder = function (datasetId, data) {
        var url = "/datasets/".concat(datasetId, "/fields/order");
        return this.API.patch(url, data);
    };
    DatasetService.prototype.bulkDelete = function (datasetId, data) {
        var url = "/datasets/".concat(datasetId, "/items");
        return this.API.delete(url, data);
    };
    DatasetService.prototype.deleteAll = function (datasetId) {
        var url = "/datasets/".concat(datasetId, "/items?deletable=all");
        return this.API.delete(url);
    };
    return DatasetService;
}());
export { DatasetService };
